import filestack from 'filestack-js';

const apikey = 'AwDEdRHLpTaKP5CNChLfUz';
const Client = filestack.init(apikey);

export default Client;


// WEBPACK FOOTER //
// ./public/utils/filestack.js